import axios, { AxiosInstance, AxiosResponse } from "axios";
import { UIStateStore } from "src/stores/uiStateStore";
import { RootStoreSingleton } from "../stores/rootStore";

// NOTE: axios should be used only here and nowhere else!

// wait for 90 sec
const timeout = 9E4;
const api = axios.create({
  baseURL: 'api/',
  timeout: timeout,
}) as ApiAxiosInstance;

interface ApiAxiosInstance extends AxiosInstance {
  responseOk: Function
}

api.responseOk = function(axiosResponse: AxiosResponse<any>) {

  // TODO: Add here more checks for when the request failed

  if(!axiosResponse) {
    return false;
  }

  if(!axiosResponse.status) {
    return false;
  }

  if(axiosResponse.status > 299) {
    return false;
  }

  return true;
}

api.interceptors.response.use(interceptGlobalSuccess, interceptGlobalError);

function interceptGlobalSuccess(axiosResponse: AxiosResponse<any>) {      
  // console.debug(axiosResponse);
  return axiosResponse;
}

function interceptGlobalError(axiosError: any) {
  const uiStateStore = RootStoreSingleton.uiStateStore;
  const response = axiosError.response;

  // console.debug(axiosError);
  // console.debug(axiosError.toJSON());

  // handle Timeout
  if (axiosError.code === "ECONNABORTED") {

    // TODO: Apply retry mechanism here
    uiStateStore.pushMessage("This operation is taking longer than expected.", "error", true);
        
  }
  // handle 400:BadRequest
  else if (response.status === 400) {

    const message = response?.data?.title ?? "Bad Request."
    uiStateStore.pushMessage(`There was an error with your request: ${message}`, "error", true);

    // TODO: Handle different kind of error outputs here
    outputValidationErrors(response, uiStateStore);

  }
  // handle 401:Unauthorized
  else if (response.status === 401) {

    // NOTE: Automatic redirect to login
    window.location.pathname = "/login";

  }
  // handle 403:Forbidden
  else if (response.status === 403) {

    // TODO: Maybe think about a forbidden error page
    uiStateStore.pushMessage("Sorry, you do not have the required permissions for this action.", "error", true);        

  }

  // handle 404:NotFound
  else if (response.status === 404) {
    
    // NOTE: Dump resource path for the resource that we couldn't find
    uiStateStore.pushMessage(`The resource at path '${axiosError.config.url}' does not exist.`, "error", true);    

  }
  // handle 500:InternalServerError
  else if (response.status === 500) {
    
    // TODO: Display a button with label 'Details' 
    // that opens a dialog with the whole response as text
    const message = response?.data?.split('\r\n')[0] ?? "Internal Server Error."
    uiStateStore.pushMessage(`Oops, something went wrong: ${message}`, "error", true);

  }

  // NOTE: Propagate response to callers so
  // they can see that the request failed  
  return response;

}

function outputValidationErrors(response: any, uiStateStore: UIStateStore) {
  if (!response?.data?.errors) {
    return;
  }

  for (let errorProperty in response.data.errors) {
    response.data.errors[errorProperty].forEach((serverError: string) => {
      uiStateStore.pushMessage(serverError, "error", true);
    });
  }
}

export default api;
